var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverrideGreyLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / override") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-console",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Console-(new)-Site-Entrance",
    transform: "translate(-1226.000000, -297.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(94.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "override",
    transform: "translate(1121.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-override",
    transform: "translate(11.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1342935,12.7890489 L18.479748,12.7890489 L13.0870208,18.179958 L7.69792986,12.7890489 L11.079748,12.7890489 C10.6924753,7.61450347 9.07974804,2.63813983 5.70702076,2.13813983 C3.32883895,1.92723074 1.43429349,4.72359438 0.0179298557,10.5345035 C-0.198433781,3.90904892 1.5433844,0.407230742 5.2433844,0.0363216507 C10.7906571,-0.523678349 14.5852026,5.46723074 15.1342935,12.7908671 L15.1342935,12.7890489 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverrideGreyLight);
export default __webpack_public_path__ + "static/media/override_grey_light.13864a2686f528ed54d258a6308484c7.svg";
export { ForwardRef as ReactComponent };